import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { safeReturnTo } from '@/app/workspaces/workspaces';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { session } from '@/lib/auth/session';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({ returnTo: z.string().optional().catch(undefined) }),
  beforeLoad: ({ search }) => {
    if (session.get()) throw redirect({ href: safeReturnTo(search.returnTo) ?? '/' });
  },
  component: LoginPage,
});
